/**
 * postMessage envelopes shared between the parent platform and the
 * modules. Supports both the canonical protocol (REMOTE_MODULE_RECEIVER.md §3)
 * and the legacy bc-sso event types.
 */
export const isBcSsoMessage = (data) => {
    if (typeof data !== 'object' || data === null)
        return false;
    const t = data.type;
    return (t === 'bc_session' ||
        t === 'bc_request_session' ||
        t === 'bc-sso:token' ||
        t === 'bc-sso:reload' ||
        t === 'bc-sso:ready' ||
        t === 'bc_logout' ||
        t === 'bc-sso:logout' ||
        t === 'bc_session_terminated');
};
